import { BaseModel } from "sjs-base-model";

export default class PraticaInfoPraticaRequestModel extends BaseModel {
    public readonly idPreventivo: number = 0;
    public readonly numPratica: number = 0;
    public readonly cdg: string = "";
    public readonly dataInvioCse: string = "";
    public readonly statoId: number = 0;
    public readonly statoDescrizione: string = "";
    public readonly condizioneId: number = 0;
    public readonly condizioneDescrizione: string = "";
    public readonly referente: string = "";
    public readonly assicurazioneRvId: number = 0;
    public readonly assicurazioneRvDescrizione: string = "";
    public readonly assicurazioneRcId: number = 0;
    public readonly assicurazioneRcDescrizione: string = "";

    constructor(data: Partial<PraticaInfoPraticaRequestModel>) {
        super();

        this.update(data);
    }
}
